/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Backdrop, Modal as MuiModal, Paper } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import get from 'lodash-es/get';
import React from 'react';
import { useModal as useReactModalHook } from 'react-modal-hook';

interface ModalOptions {
  clickOutsideCloses?: boolean;
  escapeCloses?: boolean;
}

function useModal(jsxCallback, options: ModalOptions = {}, ...rest) {
  const clickOutsideCloses = get(options, 'clickOutsideCloses', false);
  const escapeCloses = get(options, 'escapeCloses', true);

  const [showModal, hideModal] = useReactModalHook(
    () => (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MuiModal
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              onClick: (e) => {
                e.stopPropagation();
                if (clickOutsideCloses) {
                  hideModal();
                }
              },
            },
          }}
          open
          onClose={(e, reason) => reason === 'escapeKeyDown' && escapeCloses && hideModal()}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', height: '100%' }}>
            <Paper
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                minWidth: 480,
                maxWidth: '90vw',
                maxHeight: '80vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
              }}
            >
              {jsxCallback()}
            </Paper>
          </div>
        </MuiModal>
      </LocalizationProvider>
    ),
    ...rest
  );

  return [showModal, hideModal];
}

export default useModal;
